module.exports = __webpack_public_path__ + "img/foto-voz.67122e53.png";